/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Email-адрес для получения уведомлений
 * @export
 * @interface UserNotificationEmail
 */
export interface UserNotificationEmail {
  /**
   * UUID записи
   * @type {string}
   * @memberof UserNotificationEmail
   */
  uuid: string
  /**
   * Email-адрес
   * @type {string}
   * @memberof UserNotificationEmail
   */
  email: string
}

/**
 * Check if a given object implements the UserNotificationEmail interface.
 */
export function instanceOfUserNotificationEmail(
  value: object
): value is UserNotificationEmail {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('email' in value) || value['email'] === undefined) return false
  return true
}

export function UserNotificationEmailFromJSON(
  json: any
): UserNotificationEmail {
  return UserNotificationEmailFromJSONTyped(json, false)
}

export function UserNotificationEmailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserNotificationEmail {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    email: json['email'],
  }
}

export function UserNotificationEmailToJSON(
  value?: UserNotificationEmail | null
): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    email: value['email'],
  }
}
